<template>
  <!--拼团-->
  <div>
    <nav-header
      ref="navHeader"
      v-bind:showSearch="p_showSearch"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal"
      v-bind:loginModalFlag="p_loginModalFlag"></nav-header>
    <nav-bread>
      <span slot="address">填写信息</span>
    </nav-bread>
    <div class="checkout-page">
      <div class="container">
        <div class="checkout-addr">
          <div class="check-step">
            <ul>
              <li class="cur"><span>预约信息</span></li>
              <li><span>确认订单</span></li>
              <li><span>下单成功</span></li>
            </ul>
          </div>
          <el-alert
            title="请认真填写真实信息，用于出具报告使用"
            type="warning">
          </el-alert>
          <div class="appoint">
            <el-form ref="appointObj" :model="appointObj" :rules="appointRule" inline-message label-width="110px" :validate-on-rule-change="false">
              <el-form-item :label="'登记方式'" prop="apptType">
                <el-radio-group v-model="appointObj.apptType" @change="changeApptType">
                  <el-radio :label="0">线上预约登记</el-radio>
                  <!--<el-radio :label="1">现场信息登记</el-radio>-->
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="'预约日期'" prop="apptTime" v-if="appointObj.apptType === 0">
                <el-tag v-for="(item, index) in newOrderappt" :key="index" :type="appointObj.apptTime === item ? 'success' : ''" @click.native="[appointObj.apptTime = appointObj.apptTime === item ? '' : item, $set(appointObj, 'apptDate', '')]">{{item}}</el-tag>
              </el-form-item>
              <el-form-item label="预约时间段" prop="apptDate" v-if="appointObj.apptTime && appointObj.apptType === 0">

                <el-tag class="apptTime" v-for="time in newTimes" :key="time" @click.native="orderappt[appointObj.apptTime][time].current >= orderappt[appointObj.apptTime][time].max || isValidTime(time) ? '' : appointObj.apptDate = appointObj.apptDate === time ? '' : time"
                        :type="appointObj.apptDate === time ? 'success' : orderappt[appointObj.apptTime][time].current >= orderappt[appointObj.apptTime][time].max || isValidTime(time) ? 'info' : ''">
                  <div>{{time}} {{orderappt[appointObj.apptTime][time].current >= orderappt[appointObj.apptTime][time].max || isValidTime(time) ? '' : groupHandle(orderappt[appointObj.apptTime][time].group)}}</div>
                </el-tag>

                <p style="font-size:12px;color:red;">预约时间段前{{apptDeadline}}分钟停止拼团，未拼团成功将统一退款</p>
              </el-form-item>
              <el-form-item label="受检者" prop="apptName">
                <el-input v-model="appointObj.apptName" clearable placeholder="被检测人姓名"></el-input>
              </el-form-item>
              <!--<el-form-item label="姓名全拼/英文名" prop="apptUsName">-->
              <!--<el-input v-model="appointObj.apptUsName" clearable></el-input>-->
              <!--</el-form-item>-->
              <el-form-item label="性别" prop="apptSex">
                <el-radio-group v-model="appointObj.apptSex">
                  <el-radio :label='1'>男</el-radio>
                  <el-radio :label='0'>女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="手机号" prop="apptMobile" style="position: relative">
                <el-input v-model="appointObj.apptMobile" clearable></el-input>
                <span style="position:absolute;width:130px;left:-120px;top:20px;font-size:11px;color:red;line-height:20px;">（用于查收检测报告）</span>
              </el-form-item>
              <el-form-item label="证件类型" prop="apptCert">
                <el-select v-model="appointObj.apptCert" @change="changeApptCert">
                  <el-option
                    v-for="item in apptCertList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="证件号码" prop="apptCertNo">
                <el-input v-model="appointObj.apptCertNo" clearable></el-input>
              </el-form-item>
              <el-form-item label="现住地址" prop="sheng">
                <el-select
                  v-model="appointObj.sheng"
                  @change="choseProvince"
                  placeholder="省级地区" clearable>
                  <el-option
                    v-for="item in province"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" prop="shi">
                <el-select
                  v-model="appointObj.shi"
                  @change="choseCity"
                  placeholder="市级地区" clearable>
                  <el-option
                    v-for="item in shi1"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" prop="qu">
                <el-select
                  v-model="appointObj.qu"
                  @change="choseBlock"
                  placeholder="区级地区" clearable>
                  <el-option
                    v-for="item in qu1"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" prop="detailInfo">
                <el-input type="textarea" placeholder="请填写实际居住地址，如没有长期居住地址可填暂住酒店地址" v-model="appointObj.detailInfo" clearable></el-input>
              </el-form-item>
              <el-form-item label="所属单位" prop="apptCompany">
                <el-input v-model="appointObj.apptCompany" placeholder="请填写真实所属单位，学生可填写所在学校，如无可填写自由职业" clearable></el-input>
              </el-form-item>
              <el-form-item label="单位性质" prop="companyNature">
                <el-select v-model="appointObj.companyNature" placeholder="单位性质" clearable>
                  <el-option
                    v-for="item in companyNatureList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="来自地区" prop="fromRegion">
                <el-select v-model="appointObj.fromRegion" placeholder="来自地区" clearable>
                  <el-option
                    v-for="item in fromRegionList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="近14天是否到过疫情中高风险地区" prop="apptEpidemicArea" label-width="180px">
                <el-radio-group v-model="appointObj.apptEpidemicArea">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="近14天是否接触过来自疫情中高风险地区的亲属朋友" prop="apptContactEpidemicArea" label-width="180px">
                <el-radio-group v-model="appointObj.apptContactEpidemicArea">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="近14天是否接触过可疑病例及发热病人" prop="apptHighRiskGroups" label-width="180px">
                <el-radio-group v-model="appointObj.apptHighRiskGroups">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="近14天是否有发热咳嗽等症状" prop="aptFeverCough" label-width="180px">
                <el-radio-group v-model="appointObj.aptFeverCough">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="近14天家人朋友是否有发热咳嗽等症状" prop="aptContactFeverCough" label-width="180px">
                <el-radio-group v-model="appointObj.aptContactFeverCough">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="查看全国中高风险地区" prop="areaCheck" label-width="180px">
                <img src="../../assets/areaCheck.jpg" style="width: 150px;height: 150px;display: block;"/>
                <el-checkbox v-model="appointObj.areaCheck">已扫码查看</el-checkbox>
              </el-form-item>
            </el-form>
          </div>
          <div class="invoice">
            <el-form ref="dataForm" :inline="true" :model="invoiceObj" :rules="dataRule" label-width="80px" id="dataForm">
              <el-row class="invoice_base">
                <el-col :span="24">
                  <el-form-item label="获知渠道:" label-width="100px">
                    <el-select v-model="invoiceObj.access" clearable>
                      <el-option
                        v-for="item in accessList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="invoice_base">
                <el-col :span="24">
                  <el-form-item label="是否开具发票:" label-width="100px" prop="invoiceFlag">
                    <el-select v-model="invoiceObj.invoiceFlag" @change="e => changeRule('invoiceFlag', e)">
                      <el-option label="暂不开票" value="0"></el-option>
                      <el-option label="开具发票" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <template v-if="invoiceObj.invoiceFlag != 0">
                <el-row class="invoice_info">
                  <el-col :span="24">
                    <el-form-item label="抬头类型" prop="userType"
                                  :rules="[
                                    { required: true, message: '抬头类型不能为空' }
                                  ]">
                      <el-select v-model="invoiceObj.userType" @change="e => changeRule('userType', e)">
                        <el-option label="个人" value="0"></el-option>
                        <el-option label="企业" value="1"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="发票类型" prop="invoiceType" v-if="invoiceObj.userType == '1'"
                                  :rules="[
                                    { required: true, message: '发票类型不能为空' }
                                  ]">
                      <el-select v-model="invoiceObj.invoiceType" @change="e => changeRule('invoiceType', e)">
                        <el-option label="普通发票" value="0"></el-option>
                        <!--<el-option label="专用发票" value="1"></el-option>-->
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="发票抬头" prop="invoice"
                                  :rules="[
                                    { required: true, message: '发票抬头不能为空' },
                                    { max: 30, message: '长度不能超过30个字符' }
                                  ]">
                      <el-autocomplete
                        v-if="invoiceObj.userType == '1'"
                        v-model="invoiceObj.invoice"
                        :fetch-suggestions="querySearchInvoice"
                        @select="handleSelectInvoice">
                        <template slot-scope="{ item }">
                          <div class="autocompleteInvoice">
                            <div class="name">
                              <p>{{ item.value }}</p>
                              <p class="tin">{{ item.tin }}</p>
                            </div>
                            <div class="reported">
                              <a v-if="item.status === -1" style="color: #8b8b8b;">已上报</a>
                              <a v-else @click="reportedHandle(item, item.id)">错误上报</a>
                            </div>
                          </div>
                        </template>
                      </el-autocomplete>
                      <el-input v-else v-model="invoiceObj.invoice"></el-input>
                    </el-form-item>
                    <!--企业类型-->
                    <template v-if="invoiceObj.userType == '1'">
                      <el-form-item label="税号" prop="tin"
                                    :rules="[
                                      { required: true, message: '税号不能为空' },
                                      { max: 20, message: '长度不能超过20个字符' }
                                    ]">
                        <el-input v-model="invoiceObj.tin"></el-input>
                      </el-form-item>
                      <!--专用类型-->
                      <template v-if="invoiceObj.invoiceType == '1'">
                        <el-form-item label="开户银行" prop="bankDeposit"
                                      :rules="[
                                        { required: true, message: '开户银行不能为空' },
                                        { max: 50, message: '长度不能超过50个字符' }
                                      ]">
                          <el-input v-model="invoiceObj.bankDeposit"></el-input>
                        </el-form-item>
                        <el-form-item label="银行账号" prop="bankAccount"
                                      :rules="[
                                        { required: true, message: '银行账号不能为空' },
                                        { max: 20, message: '长度不能超过20个字符' }
                                      ]">
                          <el-input v-model="invoiceObj.bankAccount"></el-input>
                        </el-form-item>
                        <el-form-item label="企业地址" prop="address"
                                      :rules="[
                                        { required: true, message: '企业地址不能为空' },
                                        { max: 100, message: '长度不能超过100个字符' }
                                      ]">
                          <el-input v-model="invoiceObj.address"></el-input>
                        </el-form-item>
                        <el-form-item label="企业电话" prop="mobile"
                                      :rules="[
                                        { required: true, message: '企业电话不能为空' },
                                        { max: 20, message: '长度不能超过20个字符' }
                                      ]">
                          <el-input v-model="invoiceObj.mobile"></el-input>
                        </el-form-item>
                      </template>
                    </template>
                    <el-form-item label="寄送类型" prop="sendType"
                                  :rules="[
                                    { required: true, message: '寄送类型不能为空' }
                                  ]">
                      <el-select v-model="invoiceObj.sendType" @change="e => changeRule('', e)">
                        <!--<el-option label="货票同行" value="0"></el-option>-->
                        <!--<el-option label="货票分离" value="1"></el-option>-->
                        <el-option label="电子发票" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="接收方式" prop="invoiceReceiveValue"
                                  v-if="invoiceObj.sendType === '2'"
                                  :rules="invoiceObj.invoiceReceiveType == 0 ? [
                                    { required: true, message: '接收方式不能为空' },
                                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                                  ] : [
                                    { required: true, message: '接收方式不能为空' },
                                    { pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号', trigger: ['blur', 'change'] }
                                  ]">
                      <el-input placeholder="请输入" v-model="invoiceObj.invoiceReceiveValue">
                        <el-select v-model="invoiceObj.invoiceReceiveType" slot="prepend" placeholder="请选择" style="width:90px">
                          <!--<el-option label="邮箱" :value="0"></el-option>-->
                          <el-option label="手机号" :value="1"></el-option>
                        </el-select>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <el-row class="invoice_base">
                <!--代理商-->
                <el-col :span="24" v-if="user.isChannel == 1 && user.channel.parentId == 0">
                  <el-form-item label="订单客户:" label-width="100px" prop="dealerName"
                                :rules="[
                                  { max: 50, message: '长度不能超过50个字符' }
                                ]">
                    <el-autocomplete
                      v-model="invoiceObj.dealerName"
                      :fetch-suggestions="querySearch"
                      placeholder="请填写"
                      @select="handleSelectCustomer"
                    ></el-autocomplete>
                  </el-form-item>
                </el-col>
                <!--经销商-->
                <el-col :span="24" v-if="user.isChannel == 1 && user.channel.parentId != 0">
                  <el-form-item label="订单客户:" label-width="100px" prop="customerName"
                                :rules="[
                                  { max: 50, message: '长度不能超过50个字符' }
                                ]">
                    <el-input v-model="invoiceObj.customerName" placeholder="请填写"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="备注:" label-width="100px" prop="remark"
                                :rules="[{ max: 100, message: '长度不能超过100个字符' }]">
                    <el-input type="textarea" v-model="invoiceObj.remark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>

          <div class="next-btn-wrap">
            <!--<router-link class = "btn btn&#45;&#45;m btn&#45;&#45;red" v-bind:to="{path:'orderConfirm',query:{'addressId':selectedAddrId}}">下一步</router-link>-->
            <a herf="javascript:;" class="btn btn--m btn--red" @click="toOrderConfirm">下一步</a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread'
  import NavFooter from '@/components/Footer'
  import Modal from '@/components/Modal'
  import '@/assets/css/base.css'
  import '@/assets/css/checkout.css'
  import '@/assets/css/index.css'
  import {getCookie,delCookie,compare,getCurrentTime,compareDate,deepClone} from "../../util/util";

  import axios from 'axios'

  export default {
    name: "Address2",
    data() {
      var validNo = (rule, value, call) => {
        let { apptCert } = this.appointObj
        if (apptCert === '0') {
          /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value) ? call() : call(new Error('请输入正确的证件信息'))
        } else if (apptCert === '1' || apptCert === '4') {
          if (value.length > 9 || value.length < 8) {
            call(new Error('请输入正确的证件信息'))
          } else { call() }
        } else if (apptCert === '2' || apptCert === '3') {
          /^[A-Za-z0-9]{1,20}$/.test(value) ? call() : call(new Error('请输入正确的证件信息'))
        } else if (apptCert === '5') {
          /^[A-Za-z0-9]{15}$/.test(value) ? call() : call(new Error('请输入正确的证件信息'))
        } else { call() }
      }
      return {
        p_showSearch: true,
        p_loginModalFlag: false,
        invoiceObj: {
          access: '',
          invoiceFlag: '0',
          userType: '0',
          invoiceType: '0',
          invoice: '',
          tin: '',
          bankDeposit: '',
          bankAccount: '',
          address: '',
          mobile: '',
          sendType: '2',
          invoiceReceiveType: 1,
          invoiceReceiveValue: '',
          remark: '', // 订单备注
          dealerId: '', // 经销商id
          dealerCode: '', // 经销商code
          dealerName: '', // 经销商名称
          customerName: '' // 客户名称
        },
        dataRule: {},
        clientList: [], // 代理商绑定的经销商
        appointObj: {
          apptType: 0,
          apptTime: '',
          apptDate: '',
          apptName: '',
          apptUsName: '',
          apptSex: 1,
          apptMobile: this.$store.state.user.mobile,
          apptCert: '0',
          apptCertNo: '',
          apptAddr: '',
          apptEpidemicArea: '',
          apptContactEpidemicArea: '',
          apptHighRiskGroups: '',
          aptFeverCough: '',
          aptContactFeverCough: '',
          apptCompany: '',
          companyNature: '',
          fromRegion: '',
          sheng: '',
          shi: '',
          qu: '',
          detailInfo: '',
          areaCheck: false
        },
        itemId: this.$route.query.itemId,
        mapJson: '../../static/json/map.json',
        // mapJson: 'https://uat.liferiverai.cn/jyw-web/static/json/map.json',
        province: '',
        shi1: [],
        qu1: [],
        city: '',
        block: '',
        appointRule: {
          apptType: [
            { required: true, message: '登记方式不能为空' }
          ],
          apptTime: [
            { required: true, message: '预约日期不能为空' }
          ],
          apptDate: [
            { required: true, message: '预约时间段不能为空' }
          ],
          apptName: [
            { required: true, pattern: '[^ \x22]+', message: '受检者不能为空' },
            { max: 50, message: '长度不能超过50个字符' }
          ],
          apptUsName: [
            { max: 50, message: '长度不能超过50个字符' }
          ],
          apptSex: [
            { required: true, message: '性别不能为空' },
          ],
          apptMobile: [
            { required: true, pattern: '[^ \x22]+', message: '手机号不能为空' },
            { pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号' }
          ],
          apptCert: [
            { required: true, pattern: '[^ \x22]+', message: '证件类型不能为空' }
          ],
          apptCertNo: [
            { required: true, pattern: '[^ \x22]+', message: '证件号码不能为空' },
            { name: '证件号码', validator: validNo }
          ],
          apptAddr: [
            { required: true, pattern: '[^ \x22]+', message: '现住地址不能为空' },
            { max: 200, message: '长度不能超过200个字符' }
          ],
          apptEpidemicArea: [
            { required: true, message: '近14天是否到过疫情中高风险地区' }
          ],
          apptContactEpidemicArea: [
            { required: true, message: '近14天是否接触过来自疫情中高风险地区的亲属朋友' }
          ],
          apptHighRiskGroups: [
            { required: true, message: '近14天是否接触过可疑病例及发热病人' }
          ],
          aptFeverCough: [
            { required: true, message: '近14天是否有发热咳嗽等症状' }
          ],
          aptContactFeverCough: [
            { required: true, message: '近14天家人朋友是否有发热咳嗽等症状' }
          ],
          apptCompany: [
            { required: true, pattern: '[^ \x22]+', message: '所属单位不能为空' },
            { max: 100, message: '长度不能超过100个字符' }
          ],
          companyNature: [
            { required: true, pattern: '[^ \x22]+', message: '单位性质不能为空' }
          ],
          fromRegion: [
            { required: true, pattern: '[^ \x22]+', message: '来自地区不能为空' }
          ],
          sheng: [
            { required: true, message: '省级不能为空'}
          ],
          shi: [
            { required: true, message: '市级不能为空'}
          ],
          qu: [
            { required: true, message: '区级不能为空'}
          ],
          detailInfo: [
            { required: true, pattern: '[^ \x22]+', message: '详细地址不能为空'},
            { max: 200, message: '长度不能超过200个字符' }
          ],
          areaCheck: [
            { required: true }
          ]
        },
        companyNatureList: [
          {
            value: '事业单位',
            label: '事业单位'
          },
          {
            value: '国企',
            label: '国企'
          },
          {
            value: '外企',
            label: '外企'
          },
          {
            value: '中外合资',
            label: '中外合资'
          },
          {
            value: '其他',
            label: '其他'
          }
        ],
        fromRegionList: [
          {
            value: '本市',
            label: '本市'
          },
          {
            value: '境外',
            label: '境外'
          },
          // {
          //   value: '湖北（除武汉）',
          //   label: '湖北（除武汉）'
          // },
          // {
          //   value: '武汉',
          //   label: '武汉'
          // },
          {
            value: '其他地区',
            label: '其他地区'
          }
        ],
        orderappt: [],
        times: [
          {
            label: '09:30~10:30'
          }, {
            label: '10:30~11:30'
          }, {
            label: '12:30~13:30'
          }, {
            label: '13:30~14:30'
          }, {
            label: '14:30~15:30'
          }, {
            label: '15:30~16:30'
          }, {
            label: '16:30~17:30'
          }
        ],
        groupMin: parseInt(this.$route.query.groupMin),
        groupGoods: this.$route.query.groupGoods,
        apptDeadline: parseInt(this.$route.query.apptDeadline),
        accessList: [
          {
            value: 1,
            label: '百度搜索'
          },
          {
            value: 2,
            label: '短视频（抖音/小红书等）'
          },
          {
            value: 3,
            label: '自媒体（微博/知乎/搜狐/今日头条等）'
          },
          {
            value: 4,
            label: '亲朋推荐'
          },
          {
            value: 5,
            label: '媒体广告'
          },
          {
            value: 6,
            label: '代理/医院'
          },
          {
            value: 9,
            label: '其他'
          }
        ],
        apptCertList: [
          {
            value: '0',
            label: '身份证'
          },
          {
            value: '1',
            label: '中国护照'
          },
          {
            value: '2',
            label: '台胞证'
          },
          {
            value: '3',
            label: '回乡证'
          },
          {
            value: '5',
            label: '中国绿卡'
          },
          {
            value: '4',
            label: '外籍护照'
          },
          {
            value: '7',
            label: '往来台湾通行证'
          },
          {
            value: '8',
            label: '往来港澳通行证'
          }
        ]
      }
    },
    components: {
      NavHeader,
      NavBread,
      NavFooter,
      Modal
    },
    watch: {
      $route: function (n,o) {
        if (o.name === 'Detection') {
          this.$nextTick(() => {
            this.$refs['appointObj'].resetFields()
            this.$refs['dataForm'].resetFields()
          })
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user;
      },
      c_Obj () {
        return this.$store.state.c_Obj;
      },
      checkedGoodsList () {
        return this.$store.state.checkedGoodsList;
      },
      newOrderappt () {
        return [
          ...Object.keys(this.orderappt).sort((e, a) => +new Date(e) - +new Date(a))
        ]
      },
      newTimes () {
        try {
          console.log('ok')
          return Object.keys(this.orderappt[this.appointObj.apptTime]).sort((e, i) => parseInt(`${e.split('~')[0]}`) - parseInt(`${i.split('~')[0]}`))
        } catch (e) {
          return Object.keys(this.orderappt[this.appointObj.apptTime])
        }
      },
      isValidTime () {
        return function (time) {
          let startTime = `${this.appointObj.apptTime} ${time.split('~')[0]}`
          let endTime = `${this.appointObj.apptTime} ${time.split('~')[1]}`
          return +new Date() - +new Date(new Date(startTime.replace(/-/g,'/')).setMinutes(new Date(startTime.replace(/-/g,'/')).getMinutes() - this.apptDeadline)) > 0
        }
      },
      groupHandle () {
        return function (num) {
          return num >= this.groupMin ? '已拼成，继续追加' : '还差' + (this.groupMin - num) + '人拼成'
        }
      }
    },
    activated() {
      if (getCookie("_token")) {
        this.getClientList()
        this.getOrderappt()
        this.getCityData()
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.$refs.navHeader.logout()
      }
    },
    methods: {
      p_showLoginModal() {
        this.p_loginModalFlag = true
      },

      p_closeLoginModal() {
        this.p_loginModalFlag = false
      },

      // 加载china地点数据，三级
      getCityData: function () {
        var that = this
        axios.defaults.baseURL = ''
        axios.get(this.mapJson).then(function (response) {
          axios.defaults.baseURL = process.env.API_ROOT
          if (response.status == 200) {
            var data = response.data
            that.province = []
            that.city = []
            that.block = []
            // 省市区数据分类
            for (var item in data) {
              if (item.match(/0000$/)) {//省
                that.province.push({id: item, value: data[item], children: []})
              } else if (item.match(/00$/)) {//市
                that.city.push({id: item, value: data[item], children: []})
              } else {//区
                that.block.push({id: item, value: data[item]})
              }
            }
            // 分类市级
            for (var index in that.province) {
              for (var index1 in that.city) {
                if (that.province[index].id.slice(0, 2) === that.city[index1].id.slice(0, 2)) {
                  that.province[index].children.push(that.city[index1])
                }
              }
            }
            // 分类区级
            for (var item1 in that.city) {
              for (var item2 in that.block) {
                if (that.block[item2].id.slice(0, 4) === that.city[item1].id.slice(0, 4)) {
                  that.city[item1].children.push(that.block[item2])
                }
              }
            }
          }
          else {
            console.log(response.status)
          }
        }).catch(function (error) {
          console.log(typeof+error)
        })
      },
      // 选省
      choseProvince: function (e) {
        for (var index2 in this.province) {
          if (e === this.province[index2].id) {
            this.appointObj.sheng = this.province[index2].value
            this.shi1 = this.province[index2].children
            // this.appointObj.shi= this.province[index2].children[0].value
            this.appointObj.shi= ""
            this.qu1 = this.province[index2].children[0].children
            // this.appointObj.qu= this.province[index2].children[0].children[0].value
            this.appointObj.qu= ""
            this.E = this.qu1[0].id
          }
        }
      },
      // 选市
      choseCity: function (e) {
        for (var index3 in this.city) {
          if (e === this.city[index3].id) {
            this.appointObj.shi= this.city[index3].value
            this.qu1 = this.city[index3].children
            // this.appointObj.qu= this.city[index3].children[0].value
            this.appointObj.qu= ""
            this.E = this.qu1[0].id
          }
        }
      },
      // 选区
      choseBlock: function (e) {
        this.E = e;
        for (var index3 in this.block) {
          if (e === this.block[index3].id) {
            this.appointObj.qu= this.block[index3].value
          }
        }
      },

      //获取该代理商绑定的经销商
      getClientList() {
        axios.get("/jys/client").then((res) => {
          if (res.data.code === 0) {
            this.clientList = JSON.parse(JSON.stringify(res.data.client).replace(/channelName/g,"value"))
          }
        })
      },
      querySearch(queryString, cb) {
        let clientList = this.clientList;
        let results = queryString ? clientList.filter(this.createFilter(queryString)) : clientList;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (client) => {
          return (client.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelectCustomer(item) {
        this.invoiceObj.dealerId = item.id
        this.invoiceObj.dealerCode = item.channelCode
        this.invoiceObj.dealerName = item.value
      },

      //获取发票
      querySearchInvoice(queryString, cb) {
        if (queryString) {
          axios.get("/jys/invoice/store/list", {
            params: {
              limit: 10,
              page: 1,
              invoice: queryString
            }
          }).then((res) => {
            if (res.data.code === 0) {
              cb(JSON.parse(JSON.stringify(res.data.invoiceStoreList).replace(/invoice/g,"value")))
            }
          })
        } else {
          cb([])
        }
      },
      handleSelectInvoice(item) {
        this.invoiceObj.tin = item.tin
      },
      reportedHandle(item,id) {
        axios.put('/jys/invoice/store/reported/' + id, {
        }).then((response) => {
          if (response.data.code === 0) {
            this.$message({
              message: '上报成功',
              type: 'success'
            })
            item.status = -1
          }
        })
      },

      getOrderappt() {
        axios.get("/jys/orderappt/item/" + this.itemId).then((res) => {
          this.orderappt = res.data.data
        })
      },

      changeApptType() {
        this.appointObj.apptTime = ''
        this.appointObj.apptDate = ''
      },

      changeApptCert() {
        this.appointObj.apptCertNo = ''
      },

      toOrderConfirm() {
        if (this.appointObj.areaCheck) {
          this.appointObj.apptAddr = this.appointObj.sheng + this.appointObj.shi + this.appointObj.qu + this.appointObj.detailInfo

          this.$refs['dataForm'].validate((valid) => {
            this.$refs['appointObj'].validate((valid2) => {
              if (valid && valid2) {
                let appointObj = deepClone(this.appointObj)
                let {apptDate, apptTime, apptType} = appointObj
                if (apptType === 1) {
                  apptTime = getCurrentTime(new Date())
                  apptDate = new Date().getHours() + ':' + new Date().getMinutes() + '~' + new Date().getHours() + ':' + new Date().getMinutes()
                }
                appointObj.apptDate = apptDate
                appointObj.apptTime = apptTime
                if (!apptDate) {
                  this.$message.warning('当天预约人数已满')
                } else {
                  let {checkedList, totalMoney, fromCart, checkedSpecId, groupInfo} = this.$route.query
                  let invoiceObj = JSON.stringify(this.invoiceObj)
                  localStorage.setItem('orderConfirmParams', JSON.stringify({
                    'checkedList': checkedList,
                    'addressObj': JSON.stringify({
                      'userName': this.appointObj.apptName,
                      'telNumber': this.user.mobile,
                      'provinceName': this.appointObj.sheng,
                      'cityName': this.appointObj.shi,
                      'countyName': this.appointObj.qu,
                      'detailInfo': this.appointObj.detailInfo
                    }),
                    'totalMoney': totalMoney,
                    'fromCart': fromCart,
                    'checkedSpecId': checkedSpecId,
                    'invoiceObj': invoiceObj, //发票信息
                    'appointObj': JSON.stringify(appointObj),
                    'groupInfo': groupInfo
                  }))

                  this.$router.push({
                    path: "OrderConfirm2",
                    query: {
                      'groupGoods': this.groupGoods
                    }
                  })
                }
              } else {
                this.$message.error('请认真填写预约信息')
              }
            })
          })
        } else {
          this.$message.error('请查看全国中高风险地区')
        }
      },

      // 校验规则
      changeRule (key, e) {
        // 设置值
        if (key) {
          if (key === 'invoiceFlag') {
            this.invoiceObj.userType = '0'
            this.invoiceObj.invoiceType = '0'
          } else if (key === 'userType') {
            this.invoiceObj.invoiceType = '0'
          }
          this.invoiceObj.invoice = ''
          this.invoiceObj.tin = ''
          this.invoiceObj.bankDeposit = ''
          this.invoiceObj.bankAccount = ''
          this.invoiceObj.address = ''
          this.invoiceObj.mobile = ''
          this.invoiceObj.sendType = '2'
          this.invoiceObj.invoiceReceiveType = 1
          this.invoiceObj.invoiceReceiveValue = ''
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs['dataForm'].clearValidate()
          }, 1)
        })
      }
    }
  }
</script>
<style scoped>
  .el-button--primary:focus, .el-button--primary:hover {
    background: #00C5B0;
    border-color: #00C5B0;
    color: #ffffff;
  }

  .el-icon-edit {
    width: 20px;
    height: 20px;
  }

  .el-form-item.is-success .el-input__inner,
  .el-form-item.is-success .el-input__inner:focus,
  .el-form-item.is-success .el-textarea__inner,
  .el-form-item.is-success .el-textarea__inner:focus{
    border-color: #ccc;
  }
  .container {
    width: 70%;
  }

  #dataForm >>> .el-input__inner{
    padding-left: 15px;
  }

  /*发票*/
  .invoice{
    margin-top: 20px;
    padding-top: 30px;
    border-top: 1px solid #ddd;
  }
  /deep/  .el-form-item__label{
    text-align: left;
    white-space:pre-line;
    font-size: 13px;
  }
  .invoice_base{
    margin-bottom: 0;
  }
  .invoice_base >>> .el-form-item{
    width: 50%;
  }
  .invoice_base >>> .el-form-item__content{
    width: calc(100% - 100px);
  }
  .invoice_info{
    margin-bottom: 18px;
    padding: 20px;
    background-color: #dee0e4;
  }
  .invoice_info >>> .el-form-item{
    width: 30%;
  }
  .invoice_info >>> .el-form-item__content{
    width: calc(100% - 80px);
  }
  #dataForm >>> .el-select{
    width: 100%;
  }
  /*预约*/
  .appoint{
    width: 50%;
    margin-top: 20px;
  }
  .appoint >>> .el-tag--small{
    margin-right: 15px;
    cursor: pointer;
  }
  .appoint >>> .el-select{
    width: 100%;
  }
  .appoint >>> .el-tag.el-tag--success{
    color: #f0f9eb;
    border-color: #00C5B0;
    background-color: #00C5B0;
  }
  .appoint >>> .el-form-item__error--inline{
    display: block;
  }
  .apptTime{
    width: 200px;
    text-align: center;
  }
  .appoint .el-tag.el-tag--info{
    cursor: not-allowed;
  }
  /deep/ .el-input-group__prepend{
    background-color: #ffffff;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .container {
      width: 100%;
    }
    .addr-list li dt {
      line-height: 1.6em;
      height: 1.6em;
      padding: 0;
    }
    /deep/ .navbar{
      display: none;
    }
    /deep/ .md-content {
      width: 97%;
    }

    /deep/ .md-modal {
      /* margin-top: -320px; */
      position: absolute;
      top: -22px;
    }

    /* /deep/ .editmodal {
      margin-top: -94px;
    } */

    .addr-list-wrap {
      border-bottom: 1px solid #dddddd;
    }

    #dataForm {
      margin-top: 30px;
    }
    .checkout-page {
      width: 98%;
      margin: 0 auto;
    }

    /*发票*/
    .invoice_base >>> .el-form-item{
      width: 100% !important;
    }
    .invoice_info >>> .el-form-item{
      width: 100% !important;
    }
    /*预约*/
    .appoint{
      width: 100%;
    }
    .apptTime{
      width: 100%;
    }
    .el-radio + .el-radio{
      margin-left: 0;
    }
    .el-radio {
      margin-right: 10px;
    }
    .next-btn-wrap {
      text-align: center;
    }
  }
  /deep/ .el-autocomplete {
    width: 100%;
  }
  .autocompleteInvoice {
    margin: 5px 0;
  }
  .autocompleteInvoice .name {
    display: inline-block;
    width: calc(100% - 60px);
    vertical-align: middle;
    line-height: 20px;
  }
  .autocompleteInvoice .name p:first-child {
    white-space: pre-line;
  }
  .autocompleteInvoice .tin {
    font-size: 10px;
    color: #8b8b8b;
  }
  .autocompleteInvoice .reported {
    display: inline-block;
    width: 60px;
    vertical-align: middle;
    font-size: 11px;
    color: #999999;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/appoint/Address4.vue